<template>
    <CategoryAsideBlock
        class="sort-mobile"
        :title="i18n('Sort by')"
        tabindex="-1"
    >
        <template v-for="{ key, name, direction } in selectOptions">
            <UIInputRadio
                :id="`${key}-${direction}`"
                :key="`${key}-${direction}`"
                :value="[key, direction]"
                :checked="isActive(key, direction)"
                :wrapper-class="[
                    'sort-mobile__control',
                    { 'is-active': isActive(key, direction) }
                ]"
                name="sort"
                tabindex="0"
                @input.native="setOrder(key, direction)"
            >
                <template v-if="name === 'Price'">Cena</template>
                <template v-else>{{ name }}</template>
                <span>
                    {{
                        i18n(direction === 'desc' ? 'descending' : 'ascending')
                    }}
                </span>
            </UIInputRadio>
        </template>
    </CategoryAsideBlock>
</template>

<script>
import UIInputRadio from '@vue/UI/InputRadio'
import { CategoryAsideBlock } from '../Category'
import CatalogSort from './CatalogSort.vue'

export default {
    components: {
        UIInputRadio,
        CategoryAsideBlock
    },
    extends: CatalogSort,
    mounted() {
        this.fixTabNavigation()
    },
    methods: {
        isActive(key, order) {
            return this.orderBy === key && this.orderDir === order
        },

        fixTabNavigation() {
            this.$nextTick(() => {
                const radioInputs = this.$el.querySelectorAll(
                    'input[type="radio"]'
                )

                radioInputs.forEach((input, index) => {
                    input.addEventListener('keydown', (event) => {
                        if (event.key === 'Tab' && !event.shiftKey) {
                            if (index < radioInputs.length - 1) {
                                event.preventDefault()
                                radioInputs[index + 1].focus()
                            }
                        } else if (event.key === 'Tab' && event.shiftKey) {
                            if (index > 0) {
                                event.preventDefault()
                                radioInputs[index - 1].focus()
                            }
                        }
                    })
                })
            })
        }
    }
}
</script>

<style lang="scss">
.sort-mobile {
    &__control {
        margin-bottom: 1rem;

        &.is-active {
            color: $sherpa-blue;
            font-weight: $font-weight-bold;
        }

        label {
            span {
                text-transform: lowercase;
            }
        }

        /* Style dla focusu - pokazuje wyraźną obwódkę wokół etykiety */
        input:focus {
            outline: none; /* Usuń domyślny outline przeglądarki */
        }

        /* Celujemy w drugą etykietę (z tekstem) */
        input:focus + label + label {
            outline: 2px solid $sherpa-blue;
            outline-offset: 2px;
            border-radius: 4px;
            box-shadow: 0 0 0 4px rgba(0, 120, 212, 0.2); /* Dodatkowy efekt glow */
        }
    }
}
</style>
